/* Emirati Abaya Luxe: storefront behaviour. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var T = window.theme || {};
  var S = T.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  function money(cents) {
    var format = T.moneyFormat || '{{amount}}';
    cents = Number(cents) || 0;
    function fmt(n, dec, th, de) {
      var s = (n / 100).toFixed(dec).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (s[1] ? de + s[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }
  T.money = money;

  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 2800);
  }

  function getSection(url, sectionId) {
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=' + sectionId, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  /* -------------------------------------------------------------- drawers */
  var openDrawers = [];
  class LxDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.drawer__panel');
      this.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) { e.preventDefault(); this.close(); } }.bind(this));
      this.addEventListener('keydown', this.onKey.bind(this));
    }
    open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.hidden = false;
      openDrawers.push(this);
      document.documentElement.classList.add('lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { this.classList.add('is-open'); }.bind(this)); }.bind(this));
      var focusTarget = this.querySelector('[autofocus]') || this.panel;
      setTimeout(function () { try { focusTarget.focus({ preventScroll: true }); } catch (e) {} }, 60);
      this.dispatchEvent(new CustomEvent('drawer:open'));
    }
    close() {
      this.classList.remove('is-open');
      openDrawers = openDrawers.filter(function (d) { return d !== this; }.bind(this));
      if (!openDrawers.length) document.documentElement.classList.remove('lock');
      setTimeout(function () { if (!this.classList.contains('is-open')) this.hidden = true; }.bind(this), 600);
      if (this.trigger && this.trigger.focus) try { this.trigger.focus({ preventScroll: true }); } catch (e) {}
    }
    onKey(e) {
      if (e.key === 'Escape') { this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', this.panel)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  if (!customElements.get('lx-drawer')) customElements.define('lx-drawer', LxDrawer);

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-drawer]');
    if (!t) return;
    var d = document.getElementById(t.getAttribute('data-open-drawer'));
    if (d && d.open) { e.preventDefault(); d.open(t); }
  });

  /* --------------------------------------------------------------- header */
  (function header() {
    var wrap = $('.header-wrap');
    if (!wrap) return;
    var last = window.scrollY, ticking = false;
    function onScroll() {
      var y = window.scrollY;
      wrap.classList.toggle('is-scrolled', y > 10);
      var anyOpen = !!$('.nav__item.is-open');
      if (y > last && y > 240 && !anyOpen) wrap.classList.add('is-hidden');
      else if (y < last - 4 || y < 240) wrap.classList.remove('is-hidden');
      last = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();

    $$('.nav__item[data-has-menu]').forEach(function (item) {
      var link = item.querySelector('.nav__link');
      var timer;
      function open() { clearTimeout(timer); $$('.nav__item.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
      function close() { timer = setTimeout(function () { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 160); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); open(); }
      });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { item.classList.remove('is-open'); link.focus(); } });
    });
  })();

  /* --------------------------------------------------------- announcement */
  $$('[data-announce]').forEach(function (bar) {
    var items = $$('.announce__item', bar);
    if (items.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function () {
      var cur = items[i];
      cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 800);
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------------------------------------------------------------- reveal */
  (function reveal() {
    var els = $$('[data-reveal], .hero, [data-split]');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    T.observeReveal = function (ctx) { $$('[data-reveal]', ctx).forEach(function (el) { io.observe(el); }); };
  })();
  T.observeReveal = T.observeReveal || function (ctx) { $$('[data-reveal]', ctx).forEach(function (el) { el.classList.add('is-in'); }); };

  /* -------------------------------------------------------------- carousel */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var track = document.getElementById(btn.getAttribute('aria-controls'));
    if (!track) return;
    var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    if (document.documentElement.dir === 'rtl') dir = -dir;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ------------------------------------------------------------------ cart */
  var Cart = {
    sections: ['cart-drawer'],
    add: function (items) {
      return fetch(T.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: Cart.sections.join(','), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) throw new Error(res.description || res.message || S.error);
        Cart.render(res.sections);
        Cart.refreshCount();
        document.dispatchEvent(new CustomEvent('cart:added', { detail: res }));
        if (T.cartDrawer) Cart.open(); else toast(S.added);
        return res;
      });
    },
    change: function (line, quantity) {
      return fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: Cart.sections.join(','), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) throw new Error(res.description || res.message || S.error);
        Cart.render(res.sections);
        Cart.setCount(res.item_count);
        return res;
      });
    },
    render: function (sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('[data-cart-content]');
      var cur = $('#CartDrawer [data-cart-content]');
      if (fresh && cur) { cur.replaceWith(fresh); T.observeReveal(fresh); }
    },
    refreshCount: function () {
      return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { Cart.setCount(c.item_count); });
    },
    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    },
    open: function () { var d = $('#CartDrawer'); if (d && d.open) d.open(); }
  };
  T.Cart = Cart;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-qty]');
    if (b) {
      e.preventDefault();
      var line = Number(b.getAttribute('data-line'));
      var q = Number(b.getAttribute('data-cart-qty'));
      var row = b.closest('.cart-line'); if (row) row.classList.add('grid-loading');
      Cart.change(line, q).catch(function (err) { toast(err.message); if (row) row.classList.remove('grid-loading'); });
      return;
    }
    var cartBtn = e.target.closest('[data-cart-toggle]');
    if (cartBtn && T.cartDrawer) { e.preventDefault(); var d = $('#CartDrawer'); if (d) d.open(cartBtn); }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-note]')) {
      fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    }
  });

  /* upsell + quick add buttons */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-upsell-add], [data-quick-add]');
    if (!b || b.classList.contains('is-loading')) return;
    e.preventDefault();
    var id = b.getAttribute('data-quick-add');
    if (!id) {
      var wrap = b.closest('[data-upsell]');
      var sel = wrap && wrap.querySelector('[data-variant-select]');
      id = sel && sel.value;
      if (!id) { if (sel) { sel.focus(); sel.classList.add('option--shake'); setTimeout(function () { sel.classList.remove('option--shake'); }, 500); } toast(S.chooseSize); return; }
    }
    b.classList.add('is-loading');
    Cart.add([{ id: Number(id), quantity: 1 }]).catch(function (err) { toast(err.message); }).finally(function () { b.classList.remove('is-loading'); });
  });

  /* ------------------------------------------------------------ quick view */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]');
    if (!b) return;
    e.preventDefault();
    var drawer = $('#QuickView');
    var body = drawer.querySelector('[data-quick-view-body]');
    body.innerHTML = '<div class="is-loading" style="height:60vh"></div>';
    drawer.open(b);
    var url = b.getAttribute('data-quick-view');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quick').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('[data-quick-view-content]');
      body.innerHTML = '';
      if (content) { body.appendChild(content); T.observeReveal(body); }
    }).catch(function () { window.location.href = url; });
  });

  /* --------------------------------------------------------------- product */
  class LxProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      var data = this.querySelector('script[data-product-json]');
      if (!data) return;
      this.data = JSON.parse(data.textContent);
      this.variants = this.data.variants;
      this.form = this.querySelector('form[data-product-form]');
      this.idInput = this.form && this.form.querySelector('input[name="id"]');
      this.button = this.querySelector('[data-add-button]');
      this.buttonLabel = this.button && this.button.querySelector('span');
      this.priceEl = this.querySelector('[data-price]');
      this.stock = this.querySelector('[data-stock]');
      this.selected = this.data.selected.slice();
      this.sizeIdx = this.data.sizeIndexes || [];
      this.addEventListener('change', this.onChange.bind(this));
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('click', this.onQty.bind(this));
      this.update(false);
      this.initSticky();
    }
    onChange(e) {
      var input = e.target;
      if (!input.matches('[data-option-index]')) return;
      this.selected[Number(input.getAttribute('data-option-index'))] = input.value;
      this.update(true);
    }
    onQty(e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var inp = this.querySelector('input[name="quantity"]');
      inp.value = Math.max(1, (Number(inp.value) || 1) + Number(b.getAttribute('data-qty')));
    }
    current() {
      var sel = this.selected;
      if (sel.some(function (v) { return v === null; })) return null;
      return this.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
    }
    update(userAction) {
      var self = this, v = this.current();
      /* availability of each value given the other selections */
      $$('[data-option-index]', this).forEach(function (input) {
        var idx = Number(input.getAttribute('data-option-index'));
        var ok = self.variants.some(function (va) {
          return va.available && va.options[idx] === input.value && va.options.every(function (o, i) { return i === idx || self.selected[i] === null || o === self.selected[i]; });
        });
        var pill = input.closest('.pill');
        if (pill) pill.classList.toggle('is-unavailable', !ok);
        input.checked = self.selected[idx] === input.value;
      });
      $$('[data-selected-label]', this).forEach(function (el) {
        var i = Number(el.getAttribute('data-selected-label'));
        el.textContent = self.selected[i] || '';
      });

      var priceVariant = v || this.variants.find(function (va) { return va.available; }) || this.variants[0];
      if (priceVariant && this.priceEl) {
        var cur = this.priceEl.querySelector('[data-price-current]');
        var cmp = this.priceEl.querySelector('[data-price-compare]');
        cur.innerHTML = money(priceVariant.price);
        var sale = priceVariant.compare_at_price > priceVariant.price;
        cmp.hidden = !sale;
        if (sale) cmp.innerHTML = money(priceVariant.compare_at_price);
        this.priceEl.classList.toggle('price--sale', sale);
      }

      if (this.idInput) this.idInput.value = v ? v.id : '';
      var label, disabled;
      if (!v) { label = S.chooseSize; disabled = false; }
      else if (!v.available) { label = S.soldOut; disabled = true; }
      else { label = S.addToCart; disabled = false; }
      if (this.button) { this.button.disabled = disabled; this.buttonLabel.textContent = label; }
      $$('[data-sticky-button]').forEach(function (b) { b.disabled = disabled; b.querySelector('span').textContent = label; });
      if (this.stock) {
        this.stock.hidden = !v;
        if (v) {
          this.stock.querySelector('.dot').classList.toggle('dot--out', !v.available);
          this.stock.querySelector('[data-stock-text]').textContent = v.available ? this.stock.getAttribute('data-in') : S.soldOut;
        }
      }
      if (v && userAction) {
        if (this.data.updateUrl) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (v.media) this.showMedia(v.media);
      }
    }
    showMedia(id) {
      var slide = this.querySelector('[data-media-id="' + id + '"]');
      if (!slide) return;
      var track = slide.parentElement;
      if (window.matchMedia('(min-width: 990px)').matches) {
        if (!this.closest('.drawer')) slide.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      } else {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    onSubmit(e) {
      e.preventDefault();
      var self = this;
      var v = this.current();
      if (!v) {
        var missing = this.selected.indexOf(null);
        var group = this.querySelector('[data-option-group="' + missing + '"]');
        if (group) { group.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); group.classList.remove('option--shake'); void group.offsetWidth; group.classList.add('option--shake'); }
        toast(S.chooseSize);
        return;
      }
      if (!v.available || this.button.classList.contains('is-loading')) return;
      var qty = Number((this.querySelector('input[name="quantity"]') || {}).value) || 1;
      this.button.classList.add('is-loading');
      $$('[data-sticky-button]').forEach(function (b) { b.classList.add('is-loading'); });
      Cart.add([{ id: v.id, quantity: qty }])
        .catch(function (err) { toast(err.message); })
        .finally(function () {
          self.button.classList.remove('is-loading');
          $$('[data-sticky-button]').forEach(function (b) { b.classList.remove('is-loading'); });
          var qd = self.closest('#QuickView'); if (qd && qd.close && T.cartDrawer) qd.close();
        });
    }
    initSticky() {
      var bar = $('[data-sticky-buy]');
      if (!bar || this.closest('.drawer') || !this.button || !('IntersectionObserver' in window)) return;
      var self = this;
      bar.querySelector('[data-sticky-button]').addEventListener('click', function () {
        if (!self.current()) { self.form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); }
        self.form.requestSubmit ? self.form.requestSubmit() : self.form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-buy', show);
      }).observe(this.button);
    }
  }
  if (!customElements.get('lx-product')) customElements.define('lx-product', LxProduct);

  /* --------------------------------------------------------------- gallery */
  $$('[data-gallery]').forEach(initGallery);
  function initGallery(g) {
    var track = g.querySelector('.gallery__track');
    var dots = $$('.gallery__dots span', g);
    var counter = g.querySelector('[data-gallery-counter]');
    var slides = $$('.gallery__slide', g);
    if (!track) return;
    track.addEventListener('scroll', debounce(function () {
      var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }, 60), { passive: true });
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zoom]');
      if (!b) return;
      openLightbox(slides.map(function (s) { var img = s.querySelector('img'); return img ? img.getAttribute('data-full') || img.currentSrc : null; }).filter(Boolean), Number(b.getAttribute('data-zoom')));
    });
  }
  T.initGallery = initGallery;
  function openLightbox(srcs, start) {
    var box = document.createElement('div');
    box.className = 'lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<button class="lightbox__close" type="button" aria-label="Close"><svg class="icon" viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.3"/></svg></button><div class="lightbox__track">' +
      srcs.map(function (s) { return '<img src="' + s + '" alt="" loading="lazy">'; }).join('') + '</div>';
    document.body.appendChild(box);
    document.documentElement.classList.add('lock');
    var track = box.querySelector('.lightbox__track');
    requestAnimationFrame(function () { track.scrollLeft = track.clientWidth * start * (document.documentElement.dir === 'rtl' ? -1 : 1); });
    function close() { box.remove(); if (!openDrawers.length) document.documentElement.classList.remove('lock'); document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); }
    box.querySelector('.lightbox__close').addEventListener('click', close);
    document.addEventListener('keydown', key);
    box.querySelector('.lightbox__close').focus();
  }

  /* ------------------------------------------------- lazy sections (recs) */
  class LxLazy extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); self.load(); } }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(this);
    }
    load() {
      var self = this, url = this.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var c = doc.querySelector('[data-lazy-content]');
        if (c && c.innerHTML.trim()) { self.innerHTML = c.innerHTML; self.hidden = false; self.classList.add('is-loaded'); T.observeReveal(self); syncWishlist(self); self.dispatchEvent(new CustomEvent('lazy:loaded', { bubbles: true })); }
        else if (self.hasAttribute('data-fallback-url')) { self.setAttribute('data-url', self.getAttribute('data-fallback-url')); self.removeAttribute('data-fallback-url'); self.load(); }
      }).catch(function () {});
    }
  }
  if (!customElements.get('lx-lazy')) customElements.define('lx-lazy', LxLazy);

  /* -------------------------------------------------- bought together */
  document.addEventListener('lazy:loaded', function (e) { if (e.target.matches('[data-bundle]')) initBundle(e.target); });
  document.addEventListener('change', function (e) { var b = e.target.closest('[data-bundle]'); if (b) bundleTotal(b); });
  function mainVariantId() { var p = $('lx-product[data-main] input[name="id"]'); return p && p.value; }
  function mainVariantPrice() {
    var p = $('lx-product[data-main]'); if (!p || !p.data) return 0;
    var v = p.current() || p.variants.find(function (x) { return x.available; }) || p.variants[0];
    return v ? v.price : 0;
  }
  function initBundle(b) {
    bundleTotal(b);
    var p = $('lx-product[data-main]');
    if (p) p.addEventListener('change', function () { setTimeout(function () { bundleTotal(b); }, 30); });
    var btn = b.querySelector('[data-bundle-add]');
    if (btn) btn.addEventListener('click', function () {
      var id = mainVariantId();
      if (!id) { toast(S.chooseSize); var f = $('lx-product[data-main] form'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var items = [{ id: Number(id), quantity: 1 }], missing = null;
      $$('[data-bundle-item]', b).forEach(function (it) {
        if (!it.querySelector('[data-bundle-check]').checked) return;
        var s = it.querySelector('[data-variant-select]');
        if (!s || !s.value) { missing = missing || s; return; }
        items.push({ id: Number(s.value), quantity: 1 });
      });
      if (missing) { missing.focus(); toast(S.chooseSize); return; }
      btn.classList.add('is-loading');
      Cart.add(items).catch(function (err) { toast(err.message); }).finally(function () { btn.classList.remove('is-loading'); });
    });
  }
  function bundleTotal(b) {
    var total = mainVariantPrice();
    var mp = b.querySelector('[data-bundle-main-price]'); if (mp && total) mp.innerHTML = money(total);
    $$('[data-bundle-item]', b).forEach(function (it) {
      var on = it.querySelector('[data-bundle-check]').checked;
      it.classList.toggle('is-off', !on);
      if (!on) return;
      var s = it.querySelector('[data-variant-select]');
      var opt = s && (s.tagName === 'SELECT' ? (s.value ? s.options[s.selectedIndex] : s.querySelector('option[data-price]')) : s);
      total += opt ? Number(opt.getAttribute('data-price')) || 0 : 0;
    });
    var t = b.querySelector('[data-bundle-total]'); if (t) t.innerHTML = money(total);
  }

  /* ------------------------------------------------------------- wishlist */
  var WKEY = 'lx_wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSave(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} syncWishlist(document); }
  function syncWishlist(ctx) {
    var list = wl();
    $$('[data-wishlist-toggle]', ctx).forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.hidden = !list.length; });
  }
  syncWishlist(document);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wishlist-toggle'), list = wl(), i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast(S.wishlistRemove); } else { list.unshift(h); toast(S.wishlistAdd); }
    wlSave(list.slice(0, 40));
  });
  function renderCards(handles, target, empty) {
    if (!target) return;
    if (!handles.length) { target.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(handles.map(function (h) {
      return fetch(T.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      target.innerHTML = parts.join('');
      T.observeReveal(target); syncWishlist(target);
    });
  }
  var wd = $('#WishlistDrawer');
  if (wd) wd.addEventListener('drawer:open', function () { renderCards(wl(), wd.querySelector('[data-wishlist-grid]'), wd.querySelector('[data-wishlist-empty]')); });

  /* ------------------------------------------------------- recently viewed */
  var RKEY = 'lx_recent';
  var cur = $('lx-product[data-main]');
  var recentList = [];
  try { recentList = JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) {}
  $$('[data-recently-viewed]').forEach(function (sec) {
    var exclude = sec.getAttribute('data-exclude');
    var handles = recentList.filter(function (h) { return h !== exclude; }).slice(0, Number(sec.getAttribute('data-limit')) || 8);
    if (!handles.length) return;
    sec.hidden = false;
    renderCards(handles, sec.querySelector('[data-recent-grid]'));
  });
  if (cur && cur.dataset.handle) {
    recentList = [cur.dataset.handle].concat(recentList.filter(function (h) { return h !== cur.dataset.handle; })).slice(0, 16);
    try { localStorage.setItem(RKEY, JSON.stringify(recentList)); } catch (e) {}
  }

  /* ---------------------------------------------------- predictive search */
  (function search() {
    var drawer = $('#SearchDrawer');
    if (!drawer) return;
    var input = drawer.querySelector('input[name="q"]');
    var out = drawer.querySelector('[data-predictive]');
    var idle = drawer.querySelector('[data-search-idle]');
    var ctrl;
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; idle.hidden = false; return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      fetch(T.routes.predictive + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var c = doc.querySelector('[data-predictive-content]');
          out.innerHTML = c ? c.innerHTML : '';
          idle.hidden = true;
        }).catch(function () {});
    }, 260));
  })();

  /* ------------------------------------------------------- collection facets */
  class LxFacets extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id');
      this.form = this.querySelector('form[data-facets-form]') || document.getElementById(this.getAttribute('data-form'));
      var self = this;
      document.addEventListener('change', function (e) {
        var f = e.target.form;
        if (f && (f.hasAttribute('data-facets-form') || f.hasAttribute('data-sort-form'))) self.submit(f);
      });
      document.addEventListener('submit', function (e) {
        if (e.target.hasAttribute('data-facets-form')) { e.preventDefault(); self.submit(e.target); }
      });
      document.addEventListener('click', function (e) {
        var a = e.target.closest('[data-facet-link]');
        if (a) { e.preventDefault(); self.load(a.getAttribute('href')); }
      });
      window.addEventListener('popstate', function () { self.load(window.location.href, true); });
    }
    params() {
      var fd = new FormData();
      $$('form[data-facets-form], form[data-sort-form]').forEach(function (f) { new FormData(f).forEach(function (v, k) { if (v !== '') fd.append(k, v); }); });
      return new URLSearchParams(fd).toString();
    }
    submit() { this.load(window.location.pathname + '?' + this.params()); }
    load(url, noPush) {
      var grid = this.querySelector('[data-results]');
      if (grid) grid.classList.add('grid-loading');
      var self = this;
      getSection(url, this.sectionId).then(function (doc) {
        var fresh = doc.querySelector('lx-facets');
        if (!fresh) return;
        ['[data-results]', '[data-active-filters]', '[data-count]', '[data-load-more]'].forEach(function (sel) {
          var a = self.querySelector(sel), b = fresh.querySelector(sel);
          if (a && b) a.replaceWith(b); else if (a && !b) a.remove();
        });
        var drawerBody = $('#FilterDrawer [data-filter-body]'), freshBody = doc.querySelector('[data-filter-body]');
        if (drawerBody && freshBody) {
          var open = $$('details[open]', drawerBody).map(function (d) { return d.id; });
          drawerBody.innerHTML = freshBody.innerHTML;
          open.forEach(function (id) { var d = document.getElementById(id); if (d) d.open = true; });
        }
        if (!noPush) window.history.pushState({}, '', url);
        T.observeReveal(self); syncWishlist(self);
      }).catch(function () { window.location.href = url; });
    }
  }
  if (!customElements.get('lx-facets')) customElements.define('lx-facets', LxFacets);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-load-more-btn]');
    if (!b) return;
    e.preventDefault();
    var wrap = b.closest('lx-facets');
    var url = b.getAttribute('href');
    b.classList.add('is-loading');
    getSection(url, wrap.getAttribute('data-section-id')).then(function (doc) {
      var grid = wrap.querySelector('[data-results] .products');
      $$('[data-results] .products > *', doc).forEach(function (card) { grid.appendChild(card); });
      var lm = wrap.querySelector('[data-load-more]'), fresh = doc.querySelector('[data-load-more]');
      if (lm) { if (fresh) lm.replaceWith(fresh); else lm.remove(); }
      window.history.replaceState({}, '', url);
      T.observeReveal(grid); syncWishlist(grid);
    }).catch(function () { window.location.href = url; });
  });

  /* ------------------------------------------------------------------ tabs */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.tabs__btn');
    if (!tab) return;
    var list = tab.closest('[role=tablist]');
    $$('.tabs__btn', list).forEach(function (b) {
      var on = b === tab;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  });

  /* ------------------------------------------------- localization selects */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-localization-select]')) e.target.form.submit();
  });

  /* ------------------------------------------------------------ split text */
  $$('[data-split]').forEach(function (el) {
    if (el.querySelector('.split-line')) return;
    var lines = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = lines.map(function (l, i) { return '<span class="split-line" style="--d:' + i + '"><span>' + l.trim() + '</span></span>'; }).join('');
  });
})();
